import React from 'react'
import { Route, BrowserRouter as Router, Routes } from 'react-router-dom';
import DashBoard from '../src/UI_Components/Home/DashBoard'
import ProductList from './UI_Components/Product/ProductList'
import ClientList from './UI_Components/Client/ClientList'
import AddProduct from './UI_Components/Product/AddProduct'
import AddClient from './UI_Components/Client/AddClient';
import LicenseList from './UI_Components/License/LicenseList';
import AuditLogList from './UI_Components/AuditLog/AuditLogList';
import ListuserRole from './UI_Components/UserRole/ListuserRole';
import AdduserRole from './UI_Components/UserRole/AdduserRole'
import UserList from './UI_Components/User/UserList';
import AddUser from './UI_Components/User/AddUser';
import LicenseHistory from './UI_Components/Client/LicenseHistory';
import UserPrevilege from './UI_Components/UserRole/UserPrevilege';
import EmailSettings from './UI_Components/Settings/EmailSettings';
import LicenseReport from './UI_Components/Report/LicenseReport';
const UIRoutes = () => {
    return (
        <Routes>
            <Route path="/dashboard" exact element={<DashBoard />} />
            <Route path="/product-management" element={<ProductList />} />
            <Route path="/product-add" element={<AddProduct />} />
            <Route path="/product-add/:id" element={<AddProduct />} />
            <Route path="/client-management" element={<ClientList />} />
            <Route path="/client-add" element={<AddClient />} />
            <Route path="/client-add/:id" element={<AddClient />} />
            <Route path="/license-management" element={<LicenseList />} />
            <Route path="/client-license-history/:id" element={<LicenseHistory />} />
            <Route path="/audit-log" element={<AuditLogList />} />
            <Route path="/user/Role" element={<ListuserRole />} />
            <Route path="/user/RoleAdd" element={<AdduserRole />} />
            <Route path="/user/List" element={<UserList />} />
            <Route path="/user/previleges" element={<UserPrevilege />} />
            <Route path="/user/Add" element={<AddUser />} />
            <Route path="/user/Add/:id" element={<AddUser />} />
            <Route path="/emailsettings" element={<EmailSettings />} />
            <Route path="/license-report" element={<LicenseReport />} />
        </Routes>

    )
}

export default UIRoutes